import { Wordmark } from "@/components/Wordmark";

export default function Footer() {
    return (
        <footer className="relative z-10 border-t border-[#2a2a2a] bg-[#0a0a0a] mt-16">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="md:col-span-2">
                    <Wordmark />
                    <p className="mt-4 text-sm text-[#a3a3a3] max-w-md leading-relaxed">
                        An artist-first discovery and event platform.
                    </p>
                </div>
                <div>
                    <div className="text-[10px] font-mono uppercase tracking-widest text-[#666]">
                        Discovery
                    </div>
                    <div className="mt-3 space-y-2 text-sm text-[#a3a3a3]">
                        <div>Ethiopia</div>
                        <div>Latin America</div>
                        <div>International</div>
                    </div>
                </div>
                <div>
                    <div className="text-[10px] font-mono uppercase tracking-widest text-[#666]">
                        For Artists
                    </div>
                    <div className="mt-3 space-y-2 text-sm text-[#a3a3a3]">
                        <div>Workspace</div>
                        <div>Check-In</div>
                        <div>Business</div>
                    </div>
                </div>
            </div>
            <div className="border-t border-[#2a2a2a] py-4">
                <div className="max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between text-xs font-mono text-[#666]">
                    <div>© 2026 · MVP · No payments processed on platform</div>
                    <div>v0.1</div>
                </div>
            </div>
        </footer>
    );
}
